import { jsx, jsxs } from 'react/jsx-runtime';
import { WarningOutlineIcon, ChevronRightIcon, DocumentIcon, FolderIcon } from '@sanity/icons';
import { isSanityDocument } from '@sanity/types';
import { Text } from '@sanity/ui';
import { useState, useMemo, useCallback, useEffect } from 'react';
import { SanityDefaultPreview, useSchema, useDocumentPreviewStore, useDocumentPresence, PreviewCard } from 'sanity';
import { usePaneRouter, PaneItemPreview } from './desk-cdc37ed9.js';
import 'lodash/omit.js';
import '@sanity/util/paths';
import 'sanity/router';
const getUnknownTypeFallback = (id, typeName) => ({
  title: /* @__PURE__ */jsxs("em", {
    children: ["No schema found for type ", /* @__PURE__ */jsx("code", {
      children: typeName
    })]
  }),
  subtitle: /* @__PURE__ */jsxs("em", {
    children: ["Document: ", /* @__PURE__ */jsx("code", {
      children: id
    })]
  }),
  media: () => /* @__PURE__ */jsx(WarningOutlineIcon, {})
});
function MissingSchemaType(props) {
  const {
    layout,
    value
  } = props;
  return /* @__PURE__ */jsx(SanityDefaultPreview, {
    ...getUnknownTypeFallback(value._id, value._type),
    layout
  });
}
function getIconWithFallback(icon, schemaType, defaultIcon) {
  if (icon === false) {
    return false;
  }
  return icon || schemaType && schemaType.icon || defaultIcon || false;
}
function PaneItem(props) {
  const {
    icon,
    id,
    layout = "default",
    pressed,
    schemaType,
    selected,
    title,
    value,
    margin,
    marginBottom,
    marginTop
  } = props;
  const schema = useSchema();
  const documentPreviewStore = useDocumentPreviewStore();
  const {
    ChildLink
  } = usePaneRouter();
  const documentPresence = useDocumentPresence(id);
  const hasSchemaType = Boolean(schemaType && schemaType.name && schema.get(schemaType.name));
  const [clicked, setClicked] = useState(false);
  const preview = useMemo(() => {
    if (value && isSanityDocument(value)) {
      if (!schemaType || !hasSchemaType) {
        return /* @__PURE__ */jsx(MissingSchemaType, {
          value
        });
      }
      return /* @__PURE__ */jsx(PaneItemPreview, {
        documentPreviewStore,
        icon: getIconWithFallback(icon, schemaType, DocumentIcon),
        layout,
        schemaType,
        value,
        presence: documentPresence
      });
    }
    return /* @__PURE__ */jsx(SanityDefaultPreview, {
      status: /* @__PURE__ */jsx(Text, {
        muted: true,
        children: /* @__PURE__ */jsx(ChevronRightIcon, {})
      }),
      icon: getIconWithFallback(icon, schemaType, FolderIcon),
      layout,
      title
    });
  }, [documentPreviewStore, hasSchemaType, icon, layout, schemaType, title, value, documentPresence]);
  const Link = useMemo(() => function LinkComponent(linkProps) {
    return /* @__PURE__ */jsx(ChildLink, {
      ...linkProps,
      childId: id
    });
  }, [ChildLink, id]);
  const handleClick = useCallback(e => {
    if (e.metaKey) {
      setClicked(false);
      return;
    }
    setClicked(true);
  }, []);
  useEffect(() => setClicked(false), [selected]);
  return /* @__PURE__ */jsx(PreviewCard, {
    __unstable_focusRing: true,
    as: Link,
    "data-as": "a",
    "data-ui": "PaneItem",
    margin,
    marginBottom,
    marginTop,
    onClick: handleClick,
    padding: 2,
    pressed,
    radius: 2,
    selected: selected || clicked,
    sizing: "border",
    tabIndex: -1,
    tone: "inherit",
    children: preview
  });
}
export { PaneItem };
//# sourceMappingURL=PaneItem-1e97aa6c.js.map
